(() => {
  if (window.__p3dSideTextBandLoaded) return;
  window.__p3dSideTextBandLoaded = true;

  const SELECTOR = '[data-p3d-side-text-band]';
  const instances = new Map();

  class P3DSideTextBand {
    constructor(section) {
      this.section = section;
      this.attrObserver = null;

      this.applySettings();
      this.observeAttributeChanges();
    }

    applySettings() {
      const d = this.section.dataset;

      this.section.style.setProperty('--p3d-stb-bg', d.bgColor || '#0b8f5d');
      this.section.style.setProperty('--p3d-stb-text', d.textColor || '#ffffff');

      this.section.style.setProperty('--p3d-stb-padding-top-desktop', `${parseInt(d.paddingTopDesktop || '76', 10)}px`);
      this.section.style.setProperty('--p3d-stb-padding-top-mobile', `${parseInt(d.paddingTopMobile || '44', 10)}px`);
      this.section.style.setProperty('--p3d-stb-padding-bottom-desktop', `${parseInt(d.paddingBottomDesktop || '76', 10)}px`);
      this.section.style.setProperty('--p3d-stb-padding-bottom-mobile', `${parseInt(d.paddingBottomMobile || '44', 10)}px`);

      this.section.style.setProperty('--p3d-stb-title-size-desktop', `${parseInt(d.titleSizeDesktop || '54', 10)}px`);
      this.section.style.setProperty('--p3d-stb-title-size-mobile', `${parseInt(d.titleSizeMobile || '34', 10)}px`);
      this.section.style.setProperty('--p3d-stb-body-size-desktop', `${parseInt(d.bodySizeDesktop || '18', 10)}px`);
      this.section.style.setProperty('--p3d-stb-body-size-mobile', `${parseInt(d.bodySizeMobile || '17', 10)}px`);

      this.section.style.setProperty('--p3d-stb-title-inset-desktop', `${parseInt(d.titleInsetDesktop || '20', 10)}px`);
      this.section.style.setProperty('--p3d-stb-title-inset-mobile', `${parseInt(d.titleInsetMobile || '0', 10)}px`);
      this.section.style.setProperty('--p3d-stb-body-max-width-desktop', `${parseInt(d.bodyMaxWidthDesktop || '640', 10)}px`);
      this.section.style.setProperty('--p3d-stb-body-max-width-mobile', `${parseInt(d.bodyMaxWidthMobile || '420', 10)}px`);
      this.section.style.setProperty('--p3d-stb-column-gap-desktop', `${parseInt(d.columnGapDesktop || '72', 10)}px`);
      this.section.style.setProperty('--p3d-stb-column-gap-mobile', `${parseInt(d.columnGapMobile || '24', 10)}px`);
    }

    observeAttributeChanges() {
      this.attrObserver = new MutationObserver((mutations) => {
        const hasDataChange = mutations.some((m) => m.type === 'attributes' && m.attributeName && m.attributeName.startsWith('data-'));
        if (!hasDataChange) return;
        this.applySettings();
      });

      this.attrObserver.observe(this.section, { attributes: true });
    }

    destroy() {
      if (this.attrObserver) this.attrObserver.disconnect();
    }
  }

  function init(scope = document) {
    const sections = scope.matches?.(SELECTOR)
      ? [scope]
      : Array.from(scope.querySelectorAll?.(SELECTOR) || []);

    sections.forEach((section) => {
      if (instances.has(section)) return;
      instances.set(section, new P3DSideTextBand(section));
    });
  }

  function destroy(scope = document) {
    const sections = scope.matches?.(SELECTOR)
      ? [scope]
      : Array.from(scope.querySelectorAll?.(SELECTOR) || []);

    sections.forEach((section) => {
      const instance = instances.get(section);
      if (!instance) return;
      instance.destroy();
      instances.delete(section);
    });
  }

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  ready(() => init(document));

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    destroy(event.target);
  });
})();
